import { RadioButtonGroup } from 'common-components'

export const KoomverRetireProductSelection = () => {
  const productKoomverRetire = [
    {
      text: 'ตลอดจนรับเงินบำนาญ',
      value: 'ตลอดจนรับเงินบำนาญ',
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        value={'ตลอดจนรับเงินบำนาญ'}
        options={productKoomverRetire}
      />
    </div>
  )
}

export default KoomverRetireProductSelection
